import { Component, model } from '@angular/core';
import { LanguageEnum } from '../../../../core/enums';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'dbx-language-switcher',
  imports: [MatMenu, TranslatePipe, MatMenuTrigger],
  templateUrl: './language-switcher.component.html',
  styleUrl: './language-switcher.component.scss',
  standalone: true,
})
export class LanguageSwitcherComponent {
  language = model.required<LanguageEnum>();

  readonly LanguageEnum = LanguageEnum;
}
